import React from 'react';
import { SelectFSLightBoxStore } from '../../_flux/stores/select_fs_light_box_store';
import { SelectFSLightBox } from '../../_flux/components/select_fs_light_box/select_fs_light_box';
import { hideAction } from '../../_flux/actions/select_fs_light_box_actions';
import { clickOnSelectMyTyreClick, clickOnContinueShopping, close } from '../../_modules/google_analytics/select_fs_light_box';
import { handleView } from '../handle_view';

const stores = {
    selectFsLightBox: SelectFSLightBoxStore,
};

function render({ selectFsLightBox }) {
    const { visible } = selectFsLightBox;

    return (
        <SelectFSLightBox
            visible={visible}
            data={selectFsLightBox.obj}
            error={{ ...selectFsLightBox }}
            onContinueShopping={onContinueShopping}
            onSelectMyTyreClick={onSelectMyTyreClick}
            onClose={onClose}
        />
    );
}

const getOptions = options => ({
    ...options,
});

export const init = (container, options) =>
    handleView(stores, render, getOptions(options), container);

const onContinueShopping = () => {
    clickOnContinueShopping();
    hideAction();
};

const onSelectMyTyreClick = () => {
    clickOnSelectMyTyreClick();
    hideAction();
    location.href = '/v1/tyre/';
};

export const onClose = () => {
    hideAction();
    close();
};
